import React from 'react';
import { Box } from '@apia/theme';
import { getSpecificParent } from '../../../../utils/dom';
import Input from '../../../common/Input';
import SearchResult from './SearchResult';
import Tree from './Tree';

const Renderer = () => {
  const [searchString, setSearchString] = React.useState('');

  const [inputRef, setInputRef] = React.useState<HTMLInputElement | null>(null);
  React.useEffect(() => {
    if (inputRef) inputRef.focus();
  }, [inputRef]);

  return (
    <Box className="menu__content">
      <Box className="menu__searchBox">
        <Input
          asMaterial
          ref={setInputRef}
          className="menu__search"
          onChange={React.useCallback(
            (ev: React.ChangeEvent<HTMLInputElement>) =>
              setSearchString(ev.target.value),
            [],
          )}
          onKeyDown={React.useCallback((ev: React.KeyboardEvent) => {
            if (ev.code === 'ArrowDown') {
              ev.preventDefault();
              const wrapper = getSpecificParent(
                ev.target as HTMLElement,
                (current) => current.classList.contains('menu__content'),
              ) as HTMLElement;

              (
                wrapper.querySelector('.active [tabindex="0"]') as HTMLElement
              )?.focus();
            }
          }, [])}
          placeholder={window.LBL_SEARCH_FUNCS}
          value={searchString}
          data-test-id="search-box"
        />
      </Box>
      <Box className="menu__resultsBox">
        <SearchResult
          onArrowUpOnFirstElement={React.useCallback(() => {
            inputRef?.focus();
          }, [inputRef])}
          searchString={searchString}
        />
        <Box
          className={`${searchString !== '' ? '' : 'active'} menu`}
          sx={React.useMemo(
            () => ({
              display: searchString !== '' ? 'none' : undefined,
            }),
            [searchString],
          )}
        >
          <Tree
            onArrowUpOnFirstElement={React.useCallback(() => {
              inputRef?.focus();
            }, [inputRef])}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Renderer;
